import { render, staticRenderFns } from "./InventorySettingsPanel.vue?vue&type=template&id=42eaa5f6"
import script from "./InventorySettingsPanel.vue?vue&type=script&lang=js"
export * from "./InventorySettingsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports